<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"></svg>;

import type { SizedIconProps } from '../BaseIcon';
import { BaseIcon } from '../BaseIcon';

type MaximiseIconProps = Omit<SizedIconProps, 'children'>;

export const MaximiseIcon = ({ ...props }: MaximiseIconProps) => (
  <BaseIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M7 1C7 0.447715 7.44772 0 8 0H15C15.5523 0 16 0.447715 16 1V8C16 8.55228 15.5523 9 15 9C14.4477 9 14 8.55228 14 8V3.41421L10.7071 6.70711C10.3166 7.09763 9.68342 7.09763 9.29289 6.70711C8.90237 6.31658 8.90237 5.68342 9.29289 5.29289L12.5858 2H8C7.44772 2 7 1.55228 7 1Z"
      fill="#141B4D"
    />
    <path
      d="M3.41422 14H8C8.55229 14 9 14.4477 9 15C9 15.5523 8.55229 16 8 16H1C0.447715 16 0 15.5523 0 15V8C0 7.44772 0.447715 7 1 7C1.55228 7 2 7.44772 2 8V12.5858L5.29289 9.2929C5.68342 8.90237 6.31658 8.90237 6.70711 9.2929C7.09763 9.68342 7.09763 10.3166 6.70711 10.7071L3.41422 14Z"
      fill="#141B4D"
    />
  </BaseIcon>
);

MaximiseIcon.displayName = 'MaximiseIcon';
